import React from 'react';
import Content from './Content';
import styled from 'styled-components';

const SideBar = styled.div`
  width: 240px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.9)), url('/background.jpg') center;
  background-size: cover;
  position: sticky;
  left: 0;
  overflow-x: auto;
  box-shadow: 0px 10px 30px -12px rgba(0, 0, 0, 0.42), 0px 10px 30px -12px rgba(255, 0, 0, 0.42);
`;

const Sidebar = () => {
  return (
    <SideBar>
      <Content />
    </SideBar>
  );
};

export default Sidebar;
